import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable react/prop-types */

import React, { Component } from 'react';
import { css } from 'emotion';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { getBoundingClientObj } from '@tekion/tekion-base/utils/general';

// // ==============================
// // Menu Portal
// // ==============================
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};
export var menuPortalCSS = function menuPortalCSS(_ref) {
  var rect = _ref.rect,
    offset = _ref.offset,
    position = _ref.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var getRectRelativeToAppendToElement = function getRectRelativeToAppendToElement(rect, appendTo, isFixed) {
  if (!appendTo || isFixed) return rect;
  var appendToRect = getBoundingClientObj(appendTo);
  return _objectSpread(_objectSpread({}, rect), {}, {
    left: rect.left - appendToRect.left,
    top: rect.top - appendToRect.top,
    bottom: rect.bottom - appendToRect.top
  });
};
var getParentOffset = function getParentOffset(appendTo) {
  if (!appendTo) {
    return window.pageYOffset;
  }
  return appendTo.scrollTop;
};
var MenuPortal = /*#__PURE__*/function (_Component) {
  _inherits(MenuPortal, _Component);
  var _super = _createSuper(MenuPortal);
  function MenuPortal() {
    var _this;
    _classCallCheck(this, MenuPortal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      placement: null
    });
    // callback for occassions where the menu must "flip"
    _defineProperty(_assertThisInitialized(_this), "getPortalPlacement", function (_ref2) {
      var placement = _ref2.placement;
      var initialPlacement = function initialPlacement() {
        var menuPlacement = _this.props.menuPlacement;
        return coercePlacement(menuPlacement);
      };

      // avoid re-renders if the placement has not changed
      if (placement !== initialPlacement) {
        _this.setState({
          placement: placement
        });
      }
    });
    return _this;
  }
  _createClass(MenuPortal, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        appendTo = _this$props.appendTo,
        children = _this$props.children,
        controlElement = _this$props.controlElement,
        menuPlacement = _this$props.menuPlacement,
        position = _this$props.menuPosition,
        getStyles = _this$props.getStyles;
      var isFixed = position === 'fixed';

      // bail early if required elements aren't present
      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }
      var placementFromState = this.state.placement;
      var placement = placementFromState || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var rectRelativeToAppendToElement = getRectRelativeToAppendToElement(rect, appendTo, isFixed);
      var scrollDistance = isFixed ? 0 : getParentOffset(appendTo);
      var offset = rectRelativeToAppendToElement[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rectRelativeToAppendToElement
      };

      // same wrapper element whether fixed or portalled
      var menuWrapper = /*#__PURE__*/React.createElement("div", {
        className: css(getStyles('menuPortal', state))
      }, children);
      return appendTo ? /*#__PURE__*/createPortal(menuWrapper, appendTo) : menuWrapper;
    }
  }]);
  return MenuPortal;
}(Component);
_defineProperty(MenuPortal, "childContextTypes", {
  getPortalPlacement: PropTypes.func
});
export default MenuPortal;